<template>
  <div class="content">
    <div class="ClientContent">
      <div class="row1"></div>
      <div class="row1" style="display: inline-flex;margin-bottom: 2%;">
        <div class="title" >Modifier un utilisateur</div>
      </div>
     
      <div class="content-tab-users">
          <form @submit.prevent="modifyUser">
            <div class="wrap">
              <div class="row">
                <h5>Username*</h5>
                <input type="text" v-model="user.name" class="input" placeholder="Nom" required/>
              </div>
              <div class="row">
                <h5>Email*</h5>
                <input type="email" v-model="user.email" class="input" placeholder="Email" required/>
              </div>
              <div class="row">
                  <h5>Role*</h5>
                  <div class="role-container">
                    <div class="col">
                         
                        <label class="btn" :class="{ active: user.role == 2}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.61" height="12.627" viewBox="0 0 15.61 12.627" v-if="user.role == 2">
                                <path id="Icon_open-check" data-name="Icon open-check" d="M12.746,0,11.374,1.432,5.846,6.96,4.236,5.409,2.8,3.977,0,6.781,1.432,8.213,4.415,11.2l1.372,1.432L7.218,11.2l6.96-6.96L15.61,2.8,12.746,0Z" fill="#fff"/>
                            </svg>
                            {{role[0].text}}
                            <input class="radio" :id="role[0].value" type="radio" @change="typesvalues" :value="role[0].value" v-model="user.role"/>
                            </label>
                    </div>
                    <div class="col">
                        <label class="btn" :class="{ active: user.role == 1}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.61" height="12.627" viewBox="0 0 15.61 12.627" v-if="user.role == 1">
                                <path id="Icon_open-check" data-name="Icon open-check" d="M12.746,0,11.374,1.432,5.846,6.96,4.236,5.409,2.8,3.977,0,6.781,1.432,8.213,4.415,11.2l1.372,1.432L7.218,11.2l6.96-6.96L15.61,2.8,12.746,0Z" fill="#fff"/>
                            </svg>
                           {{role[1].text}}
                            <input class="radio" :id="role[1].value" type="radio" @change="typesvalues" :value="role[1].value" v-model="user.role"/>
                        </label>
                    </div>
                  </div>  
              </div>
                <div class="row">
                    <h5>Mot de passe*</h5>
                    <input type="password" v-model="user.password" class="input" placeholder="Mot de passe" required/>
                </div>
                <div class="row">
                    <h5>Confirmer mot de passe*</h5>
                    <input type="password" v-model="confirmPassword" class="input" placeholder="Confirmer mot de passe" required/>
                    <template v-if="errorMessage != ''">
                        <span class="errorMessage">{{errorMessage}}</span>
                    </template>
                </div>

                <div class="row">
                    <button type="submit" class="btn" @click="modifyUser">Valider</button>
                </div>
            </div>
          </form>
          
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    
  data() {
    return {
    user: null,
    role: [{text: "Administrateur", value: 2}, {text: "Utilisateur", value: 1}],
    confirmPassword: null,
    errorMessage: "",
    };
  },
  computed: {
    ...mapGetters(['usersList']),
    clientsCount() {
      return this.usersList.length;
    },
  },
  methods: {
    ...mapActions(['updateUser']),
    typesvalues() {
        console.log(this.user.role)
    },
    modifyUser() {
        if(this.confirmPassword == this.user.password) {
            if(this.confirmPassword.length >= 6) {
                this.$loading(true)
                this.updateUser({id: this.user.id, data: this.user}).then(res => {
                    this.$loading(false)
                    this.$router.push('/users')
                });
                this.errorMessage = ""
            } 
            else {
                this.errorMessage = "Le mot de passe doit comporter au moins 6 caractères"
            }
            
        } 
        else {
            this.errorMessage = "Merci de vérifier que le mot de passe saisi est le même"
        }
    }
  },
  mounted(){
    this.user = this.$route.params.user
    this.confirmPassword = this.user.password
    
  },
  
};
</script>
<style scoped  lang="scss">
// @import "node_modules/bootstrap/scss/bootstrap.scss";
// @import "node_modules/bootstrap-vue/src/index.scss";
.content {
  margin: 1% 5% 5% 5%;
  .ClientContent {
    width: 100%;
    display: inline;
    padding: 5px;
    position: relative;
    margin: 15px;
    .row1 {
      width: 100%;
      .btn {
        //margin-top: 15px;
        background-color: #22abc5;
        color: white;
        border: 1px solid #22abc5;
        border-radius: 0;
        font-size: 15px;
        width: 200px;
        height: 40px;
        &:focus {
          outline: 0;
        }
        &:hover {
          border-color: #ff8c00;
          background-color: #ff8c00;
        }
      }
      .title {
        width: 100%;
        color: #212529;
        font-weight: bold;
        font-size: 30px;
      }
      .Element {
        color: #8c9a9c;
        margin-top: 13px;
        margin-bottom: 13px;
      }
      .pagination {
        margin-top: 13px;
        margin-bottom: 13px;
        text-align: right;
      }
    }
    .search {
      font-size: 12px;
      margin: 0 auto;
      width: 94%;
      margin-bottom: 20px;
      .container_search {
      width: 100%;
      display: flex;
      box-shadow: 0px 3px 4px #8888;
      .icon {
        width: 2%;
        color: #1E8A9E;
        background-color: white;
        border: none;
        border-radius: 5px 0px 0px 5px;
        padding: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 15px;
        text-align: left;
        border-right: none;
      }
      .input {
        color: #1E8A9E;
        background-color: white;
        border: none;
        padding: 8px;
        border-radius: 0;
        width: 98%;
        border-left: none;
        &:focus {
          outline: 0;
        }
        &::placeholder {
          color: #b5bcbd;
        }
      }
    }
    }
    
    .content-tab-users {
        padding-top: 1%;
        background: #EBFAFC;
        .wrap {
        margin: 1% 4% 4% 4%;
        .row {
            display: inline;
            h5 {
                font-size: 15px;
                color: #22ABC5;
                padding-left: 1%;
                margin-top: 2%;
            }
            .input {
                color: #000000;
                background-color: white;
                padding: 12px;
                border-radius: 5px;
                width: 100%;
                border: 1px solid #22abc500;
                margin-top: 0px;
                font-family: Metropolis;
                margin-bottom: 1%;
                &:focus {
                    outline: 0;
                }
                &::placeholder {
                    color: #b5bcbd;
                }
            }
            .role-container {
                margin: 0px;
                width: 100%;
                max-width: 100%;
                display: flex;
                .btn {
                    margin: 5px;
                    padding: 10px;
                    border: 1px solid #22abc5;
                    border-radius: 5px;
                    color: #ffffff;
                    background-color: #22abc5;
                    font-family: Metropolis;
                    font-size: 15px;
                    width: 100%;
                    &.active {
                    border: 1px solid #ff8c00;
                    color: #ffffff;
                    background-color: #ff8c00;
                    display: block;
                    }
                    .radio {
                    display: none;
                    }
                    &:hover {
                    cursor: pointer;
                    }
                }

            }
            .btn {
                width: 100%;
                background: #22abc5;
                color: white;
                padding: 8px;
                margin: 4% 0% 4% 1%;
            }
            .errorMessage {
                color: #FB4444;
                padding: 1%;
            }
        }
      }
      .sortloading {
        padding-bottom: 20px;
      }
      .table {
        width: 92%;
        border-collapse: collapse;
        font-size: 12px;
        margin: 0 auto;
        overflow: hidden;
        
      }
      table {
        border-collapse: collapse;
        font-size: 12px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 1rem;
        color: #212529;
        border: 0;
        border : 1px solid #dfe1e2;
        margin-top: -8px;
        font-size: 12px;

        

        thead {
          background: #22ABC5;
          color: white;
          
          
        }

        tbody {
          .font-div,
          .font-p {
            font-size: 13px;
            margin-top: 0;
            margin-bottom: 0;
            color: #686868;
            padding-left: 15px;
            &.font-div {
              text-transform: capitalize;
            }
          }
          .actions {
            display: flex;
            text-align: center;
            .btnshow {
              width: 200px;
            }
            .btnDelete {
              width: 50px;
            }
            .btn {
              background-color: #22abc5;
              color: white;
              border: 0px;
              width: 80%;
              margin: 2px;
              font-size:13px;
              padding: 12px;
              &:hover {
                background-color: #ff8c00;
              }
            }
            .delete {
              color: white;
              background-color: #FB4444;
            }
          }
          .name {
            text-transform: capitalize;
          }
        }
      }
    }
  }
}
  

@media screen and (max-width: 425px) {
.ClientContent{
   width: 100%;
   position: relative;
  .responsiveBlock{
    display: inline;
  }
  .responsiveWidht{
    max-width: 100%;
  }
  .content-tab-users {
      .pagination {
        display: inline-block;
        justify-content: space-between;
        justify-items: center;
        width: 90%;
        text-align: center;
      }
    }
} 
}
</style>
<style lang="scss">
.content-tab-users {
  .table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: left calc(3.3rem / 2) center;
    padding-left: calc(1.3rem + -0.35em);
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    font-size:12px;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #eff7f9;
  }

  .table-striped tbody tr {
    background-color: #FFFFFF;
  }
  
  .table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left,
  .table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
    background-position: right calc(0.75rem / 2) center;
    //padding-left: calc(0.75rem + 0.65em);
    min-width: 70px;
    outline: 0;
    border:1px solid #e9eaeb;
    font-size: 15px;
  }
  .table.b-table > thead > tr > [aria-sort="ascending"],
  .table.b-table > tfoot > tr > [aria-sort="ascending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort="descending"],
  .table.b-table > tfoot > tr > [aria-sort="descending"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }
  .table.b-table > thead > tr > [aria-sort],
  .table.b-table > tfoot > tr > [aria-sort] {
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;
  }
  .table.b-table > thead > tr > [aria-sort="none"],
  .table.b-table > tfoot > tr > [aria-sort="none"] {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e");
  }

  .table tbody td {
    border-bottom: 1px solid #dee2e6;
    padding: 15px;
    font-size:12px;
    border:1px solid #e9eaeb;
    padding-left: 2%;
  }
  .table thead th {
    vertical-align: middle;
    background-color: white;
    color: #5f6263;
    border-bottom: 1px solid #dee2e6;
    border-top: 1px solid #dee2e6;
    
    div {
      width: 50%;
    }
    span {
      width: 50%;
    }
  }
  .table thead tr th {
    padding: 0px;
    padding-top: 10px;
    padding-bottom: 10px;
    outline: 0;
    background: #22abc5;
    color: white;
    font-weight: lighter;
  }
  .table tbody td {
    color: #686868;
    padding:15px;
  }
  .table-sm th,
  .table-sm td {
    vertical-align: middle;
    border: 1px solid #dee2e6;
  }
  .pagination {
    display: flex;
    justify-content: space-between;
    justify-items: center;
    width: 90% !important;
    padding: 8px;
    color: #979292;
    margin: auto;
    ul {
      li {
        padding: 10px;
        button {
          border-radius: 5px;
          color: #979292;
          background-color: #e6e6e6;
          border: none;
          outline: 0;
          padding: 10px;
          &:focus {
            background-color: #c9c4c4;
          }
        }
      }
    }
  }
  .modelContent {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
#userDeleteModal___BV_modal_outer_{
    position: absolute;
    top: 130px;
    left: 32%;
    width: 35%;
    outline: 0;
    .userDeleteModal {
      background-color:white;
      padding: 30px;
      outline: 0;
      border-radius: 5px;
      box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
      text-align: center;
      h5{
        font-size:22px;
      }  
      p{
        color:#9ba2a2;
      }
      .name {
        text-transform: capitalize;
        color:#686e6f;
      }
      .form-actions {
        padding-right: 15px;
        padding-top: 20px;
        button{
          margin-right: 15px;
        }
      }
    }
  }
  #userDeleteModal___BV_modal_content_{
    outline:0;
  }
@media screen and (max-width: 768px) {

#userDeleteModal___BV_modal_outer_{
    width: 340px;
     .userDeleteModal {
      padding:10px;
      }
}
}
@media screen and (max-width: 425px) {
.content-tab-users .pagination ul li{
    padding:3px;
    display: inline;
  }
#userDeleteModal___BV_modal_outer_{
    position: absolute;
    top: 130px;
    left: 80px;
    width: 270px;
    outline: 0;
    .userDeleteModal {
      padding:15px;
      .form-actions {
        padding-right: 5px;
        padding-top: 10px;
        button{
          margin-right: 5px;
        }
      }
    }
}
}
@media screen and (max-width: 375px) {

#userDeleteModal___BV_modal_outer_{
    left: 60px;
}
}
@media screen and (max-width: 320px) {

#userDeleteModal___BV_modal_outer_{
    left: 28px;
}
}
</style>

<style scoped>
table > tr > th {
          background: #22ABC5;
          color: white;
          font-weight: lighter;
          font-size: 15px;
        }
</style>
